import { render } from "./SessionFoyerTest.vue?vue&type=template&id=49a60672"
import script from "./SessionFoyerTest.vue?vue&type=script&lang=js"
export * from "./SessionFoyerTest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vote.gikit.ru/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__